import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { financeApi } from "../../../finance-api-client";
import { queryKeys } from "../../query-keys";

export function useBoostPricing(clubId: string | undefined) {
	return useQuery({
		queryKey: queryKeys.boosts.pricing(clubId ?? ""),
		queryFn: () => financeApi.boosts.getPricing(clubId!),
		enabled: !!clubId,
	});
}

export function useBoostStatus(clubId: string | undefined) {
	return useQuery({
		queryKey: queryKeys.boosts.status(clubId ?? ""),
		queryFn: () => financeApi.boosts.getStatus(clubId!),
		enabled: !!clubId,
	});
}

export function useCreateBoostCheckout(clubId: string | undefined) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (durationDays: number) => financeApi.boosts.createCheckout(clubId!, durationDays),
		onSuccess: () => {
			if (clubId) {
				qc.invalidateQueries({
					queryKey: queryKeys.boosts.status(clubId),
				});
			}
		},
	});
}
